namespace Areas {
    "use strict";

    export function addButtonsToToolbar(buttonOptions: Array<string>, addOtherButtons: (e: any) => void = null) {
        return (e: any) =>  {
            if (_.contains(buttonOptions, "export")) {
                addExport(e);
            } 

            if (_.contains(buttonOptions, "columnChooser")) {
                addColumnChooser(e);                
            }

            if (_.contains(buttonOptions, "resetLayout")) {
                addResetLayout(e);
            }

            if (_.contains(buttonOptions, "filterBuilder")) {
                addFilterBuilder(e);
            }

            if (_.contains(buttonOptions, "downloadZip")) {
                addDownloadZip(e);
            }       
            
            const editing = e.component.option("editing");

            if (editing.mode === "batch") {
                addEditBatchButton(e);
            } else {
                addEditingButtons(e, buttonOptions);
            }

            if (addOtherButtons) {
                addOtherButtons(e);
            }
        }
    }

    export function addButtonToToolbar(toolbarOptions: any, options: any, location: string = "center") {
        toolbarOptions.items.push({
            location: location,
            locateInMenu: "auto",            
            widget: "dxButton",
            options: options
        });         
    }   

}